'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct7 from "./scala.-Product7.js";
var $p;
/** @constructor */
function $c_T7(_1, _2, _3, _4, _5, _6, _7) {
  this.pY = null;
  this.pZ = null;
  this.q0 = null;
  this.q1 = null;
  this.q2 = null;
  this.q3 = null;
  this.q4 = null;
  this.pY = _1;
  this.pZ = _2;
  this.q0 = _3;
  this.q1 = _4;
  this.q2 = _5;
  this.q3 = _6;
  this.q4 = _7;
}
export { $c_T7 as $c_T7 };
$p = $c_T7.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T7;
/** @constructor */
function $h_T7() {
}
export { $h_T7 as $h_T7 };
$h_T7.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 7;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct7.$f_s_Product7__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1050932777), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T7) && (((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pY, x$0.pY) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pZ, x$0.pZ)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q0, x$0.q0)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q1, x$0.q1)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q2, x$0.q2)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q3, x$0.q3)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.q4, x$0.q4))));
});
$p.o = (function() {
  return "Tuple7";
});
$p.b = (function() {
  return (((((((((((((("(" + this.pY) + ",") + this.pZ) + ",") + this.q0) + ",") + this.q1) + ",") + this.q2) + ",") + this.q3) + ",") + this.q4) + ")");
});
function $isArrayOf_T7(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eR)));
}
export { $isArrayOf_T7 as $isArrayOf_T7 };
var $d_T7 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T7, "scala.Tuple7", ({
  eR: 1,
  b: 1,
  c: 1,
  s0: 1,
  a: 1
}));
export { $d_T7 as $d_T7 };
